import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastService, Option, DropdownSelectComponent } from 'declarabid-library';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { LanguageService } from './core/services/language.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, DropdownSelectComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [MessageService, ToastService],
})
export class AppComponent implements OnInit {
  title = 'declarabid-private';

  private readonly _languageService = inject(LanguageService);

  public readonly languageOptions = this._languageService.languages;
  public selectedLanguage = signal<Option>(this._languageService.getCurrentLanguageOption());

  ngOnInit(): void {
    this.updateSelectedLanguage();
  }

  private updateSelectedLanguage(): void {
    const currentLanguageOption = this._languageService.getCurrentLanguageOption();
    this.selectedLanguage.set(currentLanguageOption);
  }

  onLanguageChange(selectedOption: Option): void {
    if (selectedOption && selectedOption.value !== this._languageService.getCurrentLanguage()) {
      this._languageService.changeLanguage(selectedOption.value);
    }
  }


}
